// On web, tanstack already knows how to track online/appstate
export function useReactNativeIntegration() {
  // no-op
}
